import { ErrorStateMatcher } from '@angular/material';
import { FormControl } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class NgrxErrorStateMatcher implements ErrorStateMatcher {

  isErrorState(control: FormControl | null): boolean {
    return control && control.errors && control.touched;
  }
}
